import { useEffect, useState } from "react";
import { isAndroid, isIOS } from "react-device-detect";

const AppInstallBtn = (props: {
  pageProps?: any;
}) => {
  return <AppInstallBtnContent />
}

const AppInstallBtnContent = () => {
  const [storeLink, setStoreLink] = useState<string>("");
  const text = "Download Allen App";
  
  useEffect(() => {
    if(isIOS){
      setStoreLink("https://apps.apple.com/in/app/allen-neet-jee-class-6-12/id6449251524?utm_source=Doubtnut&utm_medium=doubtnut_web&utm_campaign=doubtnut_download_allen");
      return;
    }

    if(isAndroid){
      setStoreLink("https://allen.onelink.me/90jx/wy779qen");
      return;
    }
  }, []);


  return (
    <button id="ask-doubt-app" className="ml-auto sm:ml-0 lg:hidden bg-accent font-semibold uppercase rounded-full px-2 text-xs text-white fill-primary">
      {/* eslint-disable-next-line react/jsx-no-target-blank */}
      <a
        href={storeLink}
        target="_blank"
        className="w-max py-2 px-1 normal-case flex items-center gap-2"
      >
        <span>{text}</span>
      </a>
    </button>
  );
}

export default AppInstallBtn